import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pdfcrop"
    }}>{`PDFCrop`}</h1>
    <p>{`The amount of the PDF document to place.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_ART`}</strong>{` = 1131573313`}</p>
      <p parentName="blockquote">{`Places only the area defined by the PDF author as placeable artwork.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_PDF`}</strong>{` = 1131573328`}</p>
      <p parentName="blockquote">{`Places only the area displayed by Acrobat.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_TRIM`}</strong>{` = 1131573332`}</p>
      <p parentName="blockquote">{`Places only the area that represents the final trim size of the document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_BLEED`}</strong>{` = 1131573314`}</p>
      <p parentName="blockquote">{`Places only the area that represents clipped content.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_MEDIA`}</strong>{` = 1131573325`}</p>
      <p parentName="blockquote">{`Places the area that represents the physical paper size of the original PDF document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_CONTENT_VISIBLE_LAYERS`}</strong>{` = 1131566703`}</p>
      <p parentName="blockquote">{`Places the page's bounding box using visible layers only.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CROP_CONTENT_ALL_LAYERS`}</strong>{` = 1131561324`}</p>
      <p parentName="blockquote">{`Places the page's bounding box using all layers.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      